// ErrorContext.js
import React, { createContext, useState, useContext } from "react";
import { Alert, Snackbar } from "@mui/material";

// Create context
const ErrorContext = createContext();

// Custom hook to use the ErrorContext
export const useError = () => {
  return useContext(ErrorContext);
};

// ErrorProvider component to wrap your app
export const ErrorProvider = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState(null);

  const showError = (message) => {
    setErrorMessage(message);
  };

  const hideError = () => {
    setErrorMessage(null);
  };

  return (
    <ErrorContext.Provider value={{ showError, hideError }}>
      {children}

      {/* Snackbar for global error alert */}
      <Snackbar
        open={Boolean(errorMessage)}
        autoHideDuration={6000}
        onClose={hideError}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={hideError} severity="error" sx={{ width: "100%" }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </ErrorContext.Provider>
  );
};
